import { render } from "./DiseaseDatabase.vue?vue&type=template&id=3d73d870"
import script from "./DiseaseDatabase.vue?vue&type=script&lang=js"
export * from "./DiseaseDatabase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__